import {useQuery} from '@tanstack/react-query';
import {STATION_SIDEBAR_QUERY_KEY} from '@/query/channel/menu/queryKeys';
import {MenuReqest} from '@/types/channel/menu/menu.schema';
import {getStationSidebarMenuList} from '@/api/channel/menu';
import {mapMenuSchemaToModel} from '@/types/channel/menu/menu.mapper';

const useStationSidebarMenuQuery = (params: MenuReqest) => {
  const {streamerId} = params;
  return useQuery({
    queryKey: STATION_SIDEBAR_QUERY_KEY.SIDEBAR(streamerId),
    queryFn: async () => {
      const response = await getStationSidebarMenuList(streamerId);
      return mapMenuSchemaToModel(response);
    },
    enabled: !!streamerId,
  });
};

export default useStationSidebarMenuQuery;
